import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetQuestionnaireModel } from "@core/model/query-model-questionnaire";
import { questionnaireFormDefault } from "./form.default";
import { QuestionnaireFormSchema } from "./form.rule";

export const useFormDefaultQuestionnaire = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetQuestionnaireModel | undefined) => {
    return !cachedValue
      ? questionnaireFormDefault
     : ({
        jobTitle: cachedValue.job_title,
        name: cachedValue.name,
        description: cachedValue.description,
      } as QuestionnaireFormSchema);
  };

  return {
    getDefault,
  };
};
